<template>
  <div class="container-fluid px-0">
    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
      <div>
        <p class="ck-subtitulo mb-0">
          Marcações originais do REP não podem ser alteradas nem excluídas (Portaria 671, art. 74).
          Ajustes são feitos como tratamento: incluir marcação omitida ou desconsiderar marcação indevida, sempre com motivo.
        </p>
      </div>
      <button class="btn btn-info" @click="abrirInclusao()">
        <i class="bi bi-plus-lg"></i> Incluir marcação
      </button>
    </div>

    <!-- Filtros -->
    <div class="card mb-3">
      <div class="card-body pb-1">
        <div class="row g-2">
          <div class="col-lg-4 col-md-6">
            <label>Colaborador</label>
            <select id="flt-colab" data-placeholder="Todos os colaboradores" data-allow-clear="true" style="width:100%"></select>
          </div>
          <div class="col-lg-3 col-md-6">
            <label>Filial</label>
            <select v-model.number="f.idfilial" class="form-select">
              <option :value="0">Todas</option>
              <option v-for="x in filiais" :key="x.id" :value="x.id">{{ x.text }}</option>
            </select>
          </div>
          <div class="col-lg-2 col-6">
            <label>De</label>
            <input type="date" v-model="f.datainicio" class="form-control">
          </div>
          <div class="col-lg-2 col-6">
            <label>Até</label>
            <input type="date" v-model="f.datafim" class="form-control">
          </div>
          <div class="col-lg-1 col-12 d-flex align-items-end">
            <button class="btn btn-outline-primary w-100 mb-2" @click="maisFiltros = !maisFiltros" :title="maisFiltros ? 'Menos filtros' : 'Mais filtros'">
              <i :class="maisFiltros ? 'bi bi-chevron-up' : 'bi bi-sliders'"></i>
            </button>
          </div>
        </div>

        <div class="row g-2" v-show="maisFiltros">
          <div class="col-lg-2 col-6">
            <label>Hora inicial</label>
            <input type="time" v-model="f.horainicio" class="form-control">
          </div>
          <div class="col-lg-2 col-6">
            <label>Hora final</label>
            <input type="time" v-model="f.horafim" class="form-control">
          </div>
          <div class="col-lg-2 col-6">
            <label>Tipo</label>
            <select v-model="f.tipo" class="form-select">
              <option value="">Todos</option>
              <option value="entrada">Entrada</option>
              <option value="pausa">Pausa</option>
              <option value="retorno">Retorno</option>
              <option value="saida">Saída</option>
            </select>
          </div>
          <div class="col-lg-2 col-6">
            <label>Fonte</label>
            <select v-model="f.fonte" class="form-select">
              <option value="">Todas</option>
              <option value="O">Original (REP)</option>
              <option value="I">Incluída pelo RH</option>
            </select>
          </div>
          <div class="col-lg-2 col-6">
            <label>Canal</label>
            <select v-model="f.coletor" class="form-select">
              <option value="">Todos</option>
              <option value="01">Aplicativo / WhatsApp</option>
              <option value="02">Relógio itinerante / navegador</option>
            </select>
          </div>
          <div class="col-lg-2 col-6">
            <label>Situação</label>
            <select v-model="f.situacao" class="form-select">
              <option value="">Todas</option>
              <option value="0">Válidas</option>
              <option value="1">Desconsideradas</option>
            </select>
          </div>
          <div class="col-lg-3 col-6">
            <label>Buscar</label>
            <div class="input-group">
              <select v-model="f.campo" class="form-select" style="max-width: 110px">
                <option value="nome">Nome</option>
                <option value="cpf">CPF</option>
                <option value="id">NSR</option>
              </select>
              <input type="text" v-model.trim="f.valor" class="form-control" @keyup.enter="pesquisar">
            </div>
          </div>
          <div class="col-lg-2 col-6">
            <label>Ordem</label>
            <select v-model="ordem" class="form-select">
              <option value="desc">Mais recentes</option>
              <option value="asc">Mais antigas</option>
            </select>
          </div>
          <div class="col-lg-2 col-6">
            <label>Por página</label>
            <select v-model.number="porPagina" class="form-select">
              <option v-for="n in [20, 50, 100, 200, 500]" :key="n" :value="n">{{ n }}</option>
            </select>
          </div>
        </div>

        <div class="d-flex gap-2 justify-content-end py-2">
          <button class="btn btn-light" @click="limpar"><i class="bi bi-x-lg"></i> Limpar</button>
          <button class="btn btn-info" @click="pesquisar"><i class="bi bi-search"></i> Filtrar</button>
        </div>
      </div>
    </div>

    <!-- Listagem -->
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <strong>{{ total }} marcação(ões)</strong>
        <span class="ck-subtitulo">
          <span class="badge badge-suave">O</span> original do REP
          <span class="badge text-bg-primary ms-2">I</span> incluída pelo RH
        </span>
      </div>
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0 tabela-ponto">
          <thead>
            <tr>
              <th>Data e hora</th>
              <th>Colaborador</th>
              <th>Tipo</th>
              <th>Canal</th>
              <th>NSR</th>
              <th>Situação</th>
              <th class="text-end">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="carregando"><td colspan="7" class="text-center py-4"><span class="spinner-border spinner-border-sm"></span> Carregando…</td></tr>
            <tr v-else-if="!lista.length"><td colspan="7" class="text-center text-muted py-4">Nenhuma marcação encontrada para os filtros.</td></tr>
            <tr v-for="m in lista" :key="m.id" :class="{ desconsiderada: m.desconsiderada }">
              <td class="dh">
                <strong>{{ m.hora.substring(0, 5) }}</strong>
                <small>{{ dataBR(m.data) }}</small>
              </td>
              <td>
                <div class="colab">{{ m.colaborador_nome }}</div>
                <small class="text-muted">{{ m.cpf }} · {{ m.filial_nome }}</small>
              </td>
              <td><span :class="['badge', classeTipo(m.tipo)]">{{ rotTipo(m.tipo) }}</span></td>
              <td>
                <span :class="['badge', m.fonte === 'O' ? 'badge-suave' : 'text-bg-primary']" :title="m.fonte === 'O' ? 'Original do REP' : 'Incluída pelo RH'">{{ m.fonte }}</span>
                <small class="ms-1">{{ m.origem }}</small>
                <small v-if="m.offline" class="badge text-bg-light ms-1">off-line</small>
              </td>
              <td class="nsr">{{ m.nsr || '—' }}</td>
              <td>
                <span v-if="m.desconsiderada" class="badge text-bg-danger" :title="m.motivo">Desconsiderada</span>
                <span v-else class="badge text-bg-success">Válida</span>
                <div v-if="m.motivo" class="motivo" :title="m.motivo">{{ m.motivo }}</div>
              </td>
              <td class="text-end acoes">
                <a v-if="m.link" :href="m.link" target="_blank" class="btn btn-sm btn-light" title="Comprovante do trabalhador"><i class="bi bi-receipt"></i></a>
                <button v-if="m.latitude && m.longitude" class="btn btn-sm btn-light" title="Ver localização" @click="abrirMapa(m)"><i class="bi bi-geo-alt"></i></button>
                <button v-if="m.reg === 'REP' && !m.desconsiderada" class="btn btn-sm btn-light text-danger" title="Desconsiderar marcação" @click="desconsiderar(m)"><i class="bi bi-slash-circle"></i></button>
                <button v-if="m.reg === 'REP' && m.desconsiderada" class="btn btn-sm btn-light" title="Voltar a considerar" @click="reconsiderar(m)"><i class="bi bi-arrow-counterclockwise"></i></button>
                <button v-if="m.reg === 'TRAT'" class="btn btn-sm btn-light text-danger" title="Cancelar inclusão" @click="cancelarInclusao(m)"><i class="bi bi-x-circle"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer d-flex justify-content-between align-items-center flex-wrap gap-2">
        <span class="ck-subtitulo">Página {{ pagina }} de {{ Math.max(1, Math.ceil(total / porPagina)) }}</span>
        <vue-awesome-paginate v-if="total > porPagina" :total-items="total" :items-per-page="porPagina"
                              :max-pages-shown="5" v-model="pagina" />
      </div>
    </div>

    <!-- Modal: incluir marcação (tratamento) -->
    <div class="modal fade" ref="modalInclusao" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Incluir marcação omitida</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-light small">
              A inclusão serve apenas para complementar omissões (ex.: esquecimento de marcação).
              Ela aparece no espelho e no AEJ como "incluída", com o motivo, e não entra no AFD.
            </div>
            <label>Colaborador</label>
            <select id="inc-colab" data-placeholder="Selecione o colaborador" style="width:100%"></select>
            <div class="row g-2 mt-1">
              <div class="col-6"><label>Data</label><input type="date" v-model="inc.data" :max="hojeISO" class="form-control"></div>
              <div class="col-6"><label>Hora</label><input type="time" v-model="inc.hora" class="form-control"></div>
            </div>
            <label class="mt-2">Tipo</label>
            <select v-model="inc.tipo" class="form-select">
              <option value="entrada">Entrada</option>
              <option value="pausa">Pausa</option>
              <option value="retorno">Retorno</option>
              <option value="saida">Saída</option>
            </select>
            <label class="mt-2">Motivo (obrigatório)</label>
            <textarea v-model.trim="inc.motivo" maxlength="150" class="form-control" placeholder="Ex.: colaborador esqueceu de registrar a saída; confirmado pelo gestor."></textarea>
            <small class="text-muted">{{ inc.motivo.length }}/150</small>
          </div>
          <div class="modal-footer">
            <button class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <button class="btn btn-info" @click="salvarInclusao" :disabled="salvando">
              <span v-if="salvando" class="spinner-border spinner-border-sm"></span> Incluir
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: mapa -->
    <div class="modal fade" ref="modalMapa" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Localização da marcação</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div class="modal-body p-0">
            <div id="mapa-marcacao" style="width: 100%; height: 420px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6); ☧

import Swal from 'sweetalert2'
import axios from 'axios'
import { Modal } from 'bootstrap'
import util from '../util.js'

const TIPOS = { entrada: 'Entrada', pausa: 'Pausa', retorno: 'Retorno', saida: 'Saída' }

function isoHoje(delta = 0) {
  const d = new Date(); d.setDate(d.getDate() + delta)
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().substring(0, 10)
}

function filtrosPadrao() {
  return { idcolaborador: '', idfilial: 0, datainicio: isoHoje(-6), datafim: isoHoje(0), horainicio: '', horafim: '',
           tipo: '', fonte: '', coletor: '', situacao: '', campo: 'nome', valor: '' }
}

export default {
  name: 'registroponto',
  data() {
    return {
      f: filtrosPadrao(),
      maisFiltros: false,
      ordem: 'desc',
      porPagina: 50,
      pagina: 1,
      total: 0,
      lista: [],
      filiais: [],
      carregando: false,
      salvando: false,
      inc: { idcolaborador: '', data: isoHoje(0), hora: '', tipo: 'entrada', motivo: '' },
      hojeISO: isoHoje(0),
      modalInc: null,
      modalMapa: null,
      mapa: null,
    }
  },
  mounted() {
    this.configurarSelect('#flt-colab', null, (v) => { this.f.idcolaborador = v || '' })
    this.carregarFiliais()
    const q = this.$route.query
    if (q.colaborador) {
      this.f.idcolaborador = q.colaborador
      this.f.datainicio = isoHoje(-31)
      $('#flt-colab').append(new Option('Colaborador #' + q.colaborador, q.colaborador, true, true)).trigger('change.select2')
    }
    this.pesquisar()
  },
  beforeUnmount() {
    ['#flt-colab', '#inc-colab'].forEach(s => { if ($(s).data('select2')) $(s).select2('destroy') })
    if (this.mapa) this.mapa.remove()
  },
  watch: {
    pagina() { this.carregar() },
    porPagina() { this.pesquisar() },
  },
  methods: {
    dataBR: util.dataBR,
    rotTipo(t) { return TIPOS[t] || '—' },
    classeTipo(t) {
      return { entrada: 'text-bg-success', saida: 'text-bg-danger', pausa: 'text-bg-warning', retorno: 'text-bg-info' }[t] || 'text-bg-secondary'
    },
    configurarSelect(seletor, pai, aoMudar) {
      const vself = this
      $(seletor).select2({
        ajax: {
          url: util.servidor + '/controller/select2sql.php',
          dataType: 'json',
          delay: 250,
          data: (params) => ({ q: params.term, idempresa: vself.$store.state.usuario.idempresa, tabela: 'tbcolaboradores' }),
          processResults: (data) => ({ results: data }),
        },
        allowClear: true,
        minimumInputLength: 0,
        theme: 'bootstrap',
        dropdownParent: pai ? $(pai) : $(document.body),
        language: { noResults: () => 'Nenhum resultado', searching: () => 'Buscando…' },
      }).on('change', function () { aoMudar($(this).val()) })
    },
    async carregarFiliais() {
      try {
        const r = await axios.get(util.servidor + '/controller/select2sql.php', {
          params: { idempresa: this.$store.state.usuario.idempresa, token: util.token(), tabela: 'tbfiliais' },
        })
        this.filiais = Array.isArray(r.data) ? r.data : []
      } catch (e) { this.filiais = [] }
    },
    filtroJSON() {
      const f = Object.assign({}, this.f)
      Object.keys(f).forEach(k => { if (f[k] === '' || f[k] === 0 || f[k] === null) delete f[k] })
      return JSON.stringify(f)
    },
    parametros(op, extra = []) {
      return [
        { parametro: 'op', valor: op },
        { parametro: 'idempresa', valor: this.$store.state.usuario.idempresa },
        ...extra,
      ]
    },
    async pesquisar() {
      if (this.f.datainicio && this.f.datafim && this.f.datainicio > this.f.datafim) {
        util.notif('error', 'Atenção', 'A data inicial é maior que a final.')
        return
      }
      try {
        const r = await util.reqaxios(this.parametros('qtdregistros', [{ parametro: 'filtro', valor: this.filtroJSON() }]),
                                      'post', util.servidor + '/controller/registrosdeponto.php')
        this.total = parseInt(r.data.qtdregistros) || 0
      } catch (e) { this.total = 0 }
      if (this.pagina !== 1) this.pagina = 1 // o watch recarrega
      else this.carregar()
    },
    async carregar() {
      this.carregando = true
      try {
        const r = await util.reqaxios(this.parametros('listagem', [
          { parametro: 'filtro', valor: this.filtroJSON() },
          { parametro: 'ordem', valor: this.ordem },
          { parametro: 'limit', valor: this.porPagina },
          { parametro: 'offset', valor: (this.pagina - 1) * this.porPagina },
        ]), 'post', util.servidor + '/controller/registrosdeponto.php')
        this.lista = Array.isArray(r.data) ? r.data : []
        if (!Array.isArray(r.data)) util.respostaOk(r.data)
      } catch (e) {
        this.lista = []
      } finally {
        this.carregando = false
      }
    },
    limpar() {
      this.f = filtrosPadrao()
      $('#flt-colab').val(null).trigger('change.select2')
      this.pesquisar()
    },
    abrirInclusao() {
      this.inc = { idcolaborador: this.f.idcolaborador || '', data: isoHoje(0), hora: '', tipo: 'entrada', motivo: '' }
      if (!this.modalInc) {
        this.modalInc = new Modal(this.$refs.modalInclusao)
        this.configurarSelect('#inc-colab', this.$refs.modalInclusao, (v) => { this.inc.idcolaborador = v || '' })
      }
      $('#inc-colab').val(null).trigger('change.select2')
      this.modalInc.show()
    },
    async salvarInclusao() {
      const i = this.inc
      if (!i.idcolaborador) return util.notif('error', 'Atenção', 'Selecione o colaborador.')
      if (!i.data || !i.hora) return util.notif('error', 'Atenção', 'Informe data e hora.')
      if (i.motivo.length < 5) return util.notif('error', 'Atenção', 'Descreva o motivo da inclusão.')
      this.salvando = true
      try {
        const r = await util.reqaxios(this.parametros('incluir', [
          { parametro: 'idcolaborador', valor: i.idcolaborador },
          { parametro: 'data', valor: i.data },
          { parametro: 'hora', valor: i.hora },
          { parametro: 'tipo', valor: i.tipo },
          { parametro: 'motivo', valor: i.motivo },
        ]), 'post', util.servidor + '/controller/registrosdeponto.php')
        if (util.respostaOk(r.data)) {
          this.modalInc.hide()
          util.notif('success', 'Marcação incluída', '')
          this.pesquisar()
        }
      } finally {
        this.salvando = false
      }
    },
    async desconsiderar(m) {
      const { value: motivo } = await Swal.fire({
        title: 'Desconsiderar marcação',
        html: `<div class="text-start small">${m.colaborador_nome}<br>${this.dataBR(m.data)} às ${m.hora.substring(0, 5)} · NSR ${m.nsr}<br><br>
               A marcação original continua gravada no REP e no AFD. Ela só deixa de contar na jornada (espelho e AEJ).</div>`,
        input: 'textarea',
        inputPlaceholder: 'Motivo (obrigatório)',
        inputAttributes: { maxlength: 150 },
        showCancelButton: true,
        confirmButtonText: 'Desconsiderar',
        cancelButtonText: 'Voltar',
        inputValidator: (v) => (!v || v.trim().length < 5) ? 'Informe o motivo (mínimo 5 caracteres).' : undefined,
      })
      if (!motivo) return
      const r = await util.reqaxios(this.parametros('desconsiderar', [
        { parametro: 'idregistro', valor: m.idregistro },
        { parametro: 'motivo', valor: motivo.trim() },
      ]), 'post', util.servidor + '/controller/registrosdeponto.php')
      if (util.respostaOk(r.data)) { util.notif('success', 'Marcação desconsiderada', ''); this.carregar() }
    },
    async reconsiderar(m) {
      const ok = await Swal.fire({ title: 'Voltar a considerar esta marcação?', icon: 'question', showCancelButton: true,
                                   confirmButtonText: 'Sim', cancelButtonText: 'Não' })
      if (!ok.isConfirmed) return
      const r = await util.reqaxios(this.parametros('reconsiderar', [{ parametro: 'idregistro', valor: m.idregistro }]),
                                    'post', util.servidor + '/controller/registrosdeponto.php')
      if (util.respostaOk(r.data)) this.carregar()
    },
    async cancelarInclusao(m) {
      const ok = await Swal.fire({ title: 'Cancelar esta inclusão?', text: 'O cancelamento fica registrado no histórico.', icon: 'warning',
                                   showCancelButton: true, confirmButtonText: 'Cancelar inclusão', cancelButtonText: 'Voltar' })
      if (!ok.isConfirmed) return
      const r = await util.reqaxios(this.parametros('cancelarinclusao', [{ parametro: 'idtratamento', valor: m.idtratamento }]),
                                    'post', util.servidor + '/controller/registrosdeponto.php')
      if (util.respostaOk(r.data)) { util.notif('success', 'Inclusão cancelada', ''); this.pesquisar() }
    },
    abrirMapa(m) {
      if (!this.modalMapa) {
        this.modalMapa = new Modal(this.$refs.modalMapa)
        this.$refs.modalMapa.addEventListener('shown.bs.modal', () => this.desenharMapa())
      }
      this.ponto = [parseFloat(m.latitude), parseFloat(m.longitude), m]
      this.modalMapa.show()
    },
    desenharMapa() {
      const [lat, lng, m] = this.ponto
      if (this.mapa) this.mapa.remove()
      // eslint-disable-next-line no-undef
      this.mapa = L.map('mapa-marcacao').setView([lat, lng], 16)
      // eslint-disable-next-line no-undef
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '© OpenStreetMap' }).addTo(this.mapa)
      // eslint-disable-next-line no-undef
      L.marker([lat, lng]).addTo(this.mapa).bindPopup(`${m.colaborador_nome}<br>${this.dataBR(m.data)} ${m.hora.substring(0, 5)}`).openPopup()
    },
  },
}
</script>

<style scoped lang="scss">
.tabela-ponto th { font-size: .74rem; text-transform: uppercase; letter-spacing: .04em; color: var(--ck-texto-2); font-weight: 600; background: #f7faf9; white-space: nowrap; }
.tabela-ponto td { font-size: .86rem; }
.dh { white-space: nowrap; }
.dh strong { display: block; font-size: 1rem; font-variant-numeric: tabular-nums; }
.dh small { color: var(--ck-texto-2); }
.colab { font-weight: 600; }
.nsr { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: .8rem; color: var(--ck-texto-2); }
.motivo { font-size: .74rem; color: var(--ck-texto-2); max-width: 220px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.acoes { white-space: nowrap; }
.acoes .btn { margin-left: 2px; }
tr.desconsiderada td { opacity: .6; }
tr.desconsiderada .dh strong { text-decoration: line-through; }
</style>
